module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user) ? _c('ul', {
    staticClass: "c-menu c-menu--dark"
  }, [_vm._l((Object.keys(_vm.menu)), function(type) {
    return (_vm.menu[type].length) ? [_c('li', {
      staticClass: "c-menu__category"
    }, [_vm._v(_vm._s(_vm.$t((type + ".label")).toUpperCase()))]), _vm._v(" "), _vm._l((_vm.menu[type]), function(action) {
      return _c('menu-sidebar-item', {
        key: action.label,
        attrs: {
          "item": action,
          "type": type,
          "level": 1
        }
      })
    }), _vm._v(" "), _c('li', {
      staticClass: "c-menu__divider"
    })] : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4154882c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/MenuSidebar.vue
// module id = 3092
// module chunks = 0